/**
 * Wrapper functions for polylabel (https://github.com/mapbox/polylabel)
 * @module
 */
import polylabel from "polylabel";
import { aabb2ByPolyLine2s, aabb2Center } from "./aabb2";
import { aabb2Height, aabb2Width } from "./aabb2Types";
import { polygonToGeoJsonPolygon } from "./conversion";
import type { PolyLine2 } from "./polyLine2Types";
import type { Vec2 } from "./vec2";

//Finds the most distant internal point from the polygon outline.
//Useful for placing labels.
export function poleOfInaccessibilityPolyLine2(pl: PolyLine2, precision?: number): Vec2 | null {
  return poleOfInaccessibilityPolygon([pl], precision);
}

export function poleOfInaccessibilityPolygon(pls: PolyLine2[], precision?: number): Vec2 | null {
  const polygon = polygonToGeoJsonPolygon(pls);

  const bb = aabb2ByPolyLine2s(pls);
  if (!bb) {
    return null;
  }

  const width = aabb2Width(bb);
  const height = aabb2Height(bb);

  const maxDim = Math.max(width, height);
  const minDim = Math.min(width, height);

  if (minDim / maxDim < 1e-3) {
    return aabb2Center(bb);
  }

  return polylabel(polygon, precision);
}
